"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicHealth_enDe = void 0;
exports.publicHealth_enDe = {
    metaData: {
        prismicId: 'Zp9g6xMAACwAqjxc',
        type: 'comparisontable',
        uid: 'public-health',
        lang: 'en-de',
        lastPublished: '2024-09-17T13:43:28+0000',
    },
    tableData: {
        title: 'Public health',
        collapsibleSections: false,
        hideDetails: true,
        tableData: [
            {
                section: {
                    title: '',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$0919fd18-ef55-485e-acd8-797287453d73_header',
                            text: 'Providers',
                            description: null,
                        },
                        {
                            cellId: 'table_row$0919fd18-ef55-485e-acd8-797287453d73_0',
                            type: 'CTA',
                            title: 'BARMER',
                            grey: true,
                            narrow: true,
                            buttonCaption: 'Sign up',
                            icon: 'https://images.prismic.io/feather-website/Zp9f6h5LeNNTxahy_barmer.png?auto=format,compress',
                            href: 'https://register.barmer.feather-insurance.com/',
                        },
                        {
                            cellId: 'table_row$0919fd18-ef55-485e-acd8-797287453d73_1',
                            type: 'CTA',
                            title: 'TK',
                            grey: true,
                            narrow: true,
                            buttonCaption: 'Sign up',
                            icon: 'https://images.prismic.io/feather-website/Zp9gMx5LeNNTxah__tk.png?auto=format,compress',
                            href: 'https://register.barmer.feather-insurance.com/',
                        },
                        {
                            cellId: 'table_row$0919fd18-ef55-485e-acd8-797287453d73_2',
                            type: 'CTA',
                            title: 'DAK',
                            grey: true,
                            narrow: true,
                            buttonCaption: 'Sign up',
                            icon: 'https://images.prismic.io/feather-website/Zp9gOR5LeNNTxaiC_dak.png?auto=format,compress',
                            href: 'https://register.dak.feather-insurance.com/',
                        },
                        {
                            cellId: 'table_row$0919fd18-ef55-485e-acd8-797287453d73_3',
                            type: 'CTA',
                            title: 'AOK',
                            grey: true,
                            narrow: true,
                            buttonCaption: 'Sign up',
                            icon: 'https://images.prismic.io/feather-website/ZuAKaBoQrfVKl5ao_AOK.png?auto=format,compress',
                            href: 'https://register.aok.feather-insurance.com/',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$2cf7d547-fb20-42a1-adef-bc8ecdeb246d_header',
                            text: 'Your contribution',
                            description: null,
                        },
                        {
                            cellId: 'table_row$2cf7d547-fb20-42a1-adef-bc8ecdeb246d_0',
                            text: '€—',
                            description: 'per month',
                            fontVariant: 'PRICE',
                        },
                        {
                            cellId: 'table_row$2cf7d547-fb20-42a1-adef-bc8ecdeb246d_1',
                            text: '€—',
                            description: 'per month',
                            fontVariant: 'PRICE',
                        },
                        {
                            cellId: 'table_row$2cf7d547-fb20-42a1-adef-bc8ecdeb246d_2',
                            text: '€—',
                            description: 'per month',
                            fontVariant: 'PRICE',
                        },
                        {
                            cellId: 'table_row$2cf7d547-fb20-42a1-adef-bc8ecdeb246d_3',
                            text: '€—',
                            description: 'per month',
                            fontVariant: 'PRICE',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$9885f3e4-2b6e-4174-9a26-2b8468133e9b_header',
                            text: 'English support',
                            description: null,
                        },
                        {
                            cellId: 'table_row$9885f3e4-2b6e-4174-9a26-2b8468133e9b_0',
                            rating: {
                                value: 3,
                                type: 'star',
                            },
                        },
                        {
                            cellId: 'table_row$9885f3e4-2b6e-4174-9a26-2b8468133e9b_1',
                            rating: {
                                value: 3,
                                type: 'star',
                            },
                        },
                        {
                            cellId: 'table_row$9885f3e4-2b6e-4174-9a26-2b8468133e9b_2',
                            rating: {
                                value: 3,
                                type: 'star',
                            },
                        },
                        {
                            cellId: 'table_row$9885f3e4-2b6e-4174-9a26-2b8468133e9b_3',
                            rating: {
                                value: 2,
                                type: 'star',
                            },
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$94eb6de3-8ba7-4d4b-9b7f-d1df362a9313_header',
                            text: 'Digital services',
                            description: null,
                        },
                        {
                            cellId: 'table_row$94eb6de3-8ba7-4d4b-9b7f-d1df362a9313_0',
                            modalContent: '- Teledoktor (Medical advice by phone, chat or message daily)\n\n- Doctor Finder\n\n- Homepage in English\n\n- BARMER App (not available in English yet)',
                            rating: {
                                value: 2,
                                type: 'star',
                            },
                        },
                        {
                            cellId: 'table_row$94eb6de3-8ba7-4d4b-9b7f-d1df362a9313_1',
                            modalContent: '- TK App (health card, documents download, contact and more)\n\n- App [TK-Doc](https://www.tk.de/techniker/magazin/digitale-gesundheit/apps/tk-doc-2073986) (chat with doctors)\n\n- [TK-Safe](https://www.tk.de/techniker/leistungen-und-mitgliedschaft/online-services-versicherte/elektronische-patientenakte-tk-safe-2028798) (Electronic patient file)\n\n- TK coach (stress management, fitness tips, and nutrition guide)\n\n- [Homepage in English](https://www.tk.de/en)\n\n- [Online skin check](https://www.tk.de/techniker/magazin/digitale-gesundheit/online-hautcheck-2094806) (clarify acute skin problems (only in German))\n\n- [TK-Family telephone](https://www.tk.de/techniker/leistungen-und-mitgliedschaft/informationen-versicherte/leistungen/entlastung-fuer-familien/tk-familientelefon-2009668) (only in German)\n\n- App [TK-BabyZeit](https://www.tk.de/techniker/gesundheit-und-medizin/schwangerschaft-und-geburt/mit-der-tk-sicher-ins-familienglueck-2009280) (support for parents (only in German))',
                            rating: {
                                value: 3,
                                type: 'star',
                            },
                        },
                        {
                            cellId: 'table_row$94eb6de3-8ba7-4d4b-9b7f-d1df362a9313_2',
                            modalContent: '- DAK App (submit invoices and certificates, contact, digital mailbox, view sick notes, electronic patient file and more)\n\n- [Online video consultation and skin check](https://www.dak.de/dak/leistungen/digitale-angebote/dak-online-videosprechstunde_59932)\n\n- [Homepage in English](https://www.dak.de/dak/english-2082268.html#/)',
                            rating: {
                                value: 2,
                                type: 'star',
                            },
                        },
                        {
                            cellId: 'table_row$94eb6de3-8ba7-4d4b-9b7f-d1df362a9313_3',
                            modalContent: 'Offer depends on the regional AOK branch',
                            rating: {
                                value: 1,
                                type: 'star',
                            },
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$c4e48028-cb00-4ccd-8e7e-ebfed87d0b48_header',
                            text: 'Processing speed',
                            description: null,
                        },
                        {
                            cellId: 'table_row$c4e48028-cb00-4ccd-8e7e-ebfed87d0b48_0',
                            rating: {
                                value: 3,
                                type: 'zap',
                            },
                        },
                        {
                            cellId: 'table_row$c4e48028-cb00-4ccd-8e7e-ebfed87d0b48_1',
                            rating: {
                                value: 3,
                                type: 'zap',
                            },
                        },
                        {
                            cellId: 'table_row$c4e48028-cb00-4ccd-8e7e-ebfed87d0b48_2',
                            rating: {
                                value: 3,
                                type: 'zap',
                            },
                        },
                        {
                            cellId: 'table_row$c4e48028-cb00-4ccd-8e7e-ebfed87d0b48_3',
                            rating: {
                                value: 2,
                                type: 'zap',
                            },
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$52b76edf-f35f-48ba-96c2-f8f19d809263_header',
                            text: 'Dependents coverage',
                            description: null,
                            modalContent: 'Covering your dependants is a complicated topic. To find out more about it visit [our blog](https://feather-insurance.com/blog/how-to-add-dependents-to-your-health-insurance/).',
                        },
                        {
                            cellId: 'table_row$52b76edf-f35f-48ba-96c2-f8f19d809263_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$52b76edf-f35f-48ba-96c2-f8f19d809263_1',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$52b76edf-f35f-48ba-96c2-f8f19d809263_2',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$52b76edf-f35f-48ba-96c2-f8f19d809263_3',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$d9ef3635-47ff-43b3-b429-91a843dc35b6_header',
                            text: 'Highlight',
                            description: null,
                        },
                        {
                            cellId: 'table_row$d9ef3635-47ff-43b3-b429-91a843dc35b6_0',
                            text: 'Excellent customer support in English',
                        },
                        {
                            cellId: 'table_row$d9ef3635-47ff-43b3-b429-91a843dc35b6_1',
                            text: 'Great digital services and best insurance for students',
                        },
                        {
                            cellId: 'table_row$d9ef3635-47ff-43b3-b429-91a843dc35b6_2',
                            text: 'Excellent coverage for families',
                        },
                        {
                            cellId: 'table_row$d9ef3635-47ff-43b3-b429-91a843dc35b6_3',
                            text: 'Personal support all over Germany',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$a84c7bda-8a06-4dc9-b322-5a67e629736a_header',
                            text: 'Bonus Program',
                            description: 'Receive monetary reward by participating in positive health activity.',
                            modalContent: 'Most public insurers offer bonus programs to encourage participation in preventive examinations or to contribute to the fitness of their insured. Policyholders receive cash bonuses through a bonus program. The amount of the cash reward is usually based on the type or frequency of participation.',
                        },
                        {
                            cellId: 'table_row$a84c7bda-8a06-4dc9-b322-5a67e629736a_0',
                            text: 'Up to €150',
                        },
                        {
                            cellId: 'table_row$a84c7bda-8a06-4dc9-b322-5a67e629736a_1',
                            text: 'Up to €400',
                        },
                        {
                            cellId: 'table_row$a84c7bda-8a06-4dc9-b322-5a67e629736a_2',
                            text: 'Up to €500',
                        },
                        {
                            cellId: 'table_row$a84c7bda-8a06-4dc9-b322-5a67e629736a_3',
                            text: 'Offer depends on the regional AOK branch',
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'General',
                    icon: 'https://images.prismic.io/feather-website/ZqEU1B5LeNNTxdoH_heart.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$197d1f4e-89cf-4deb-9f69-15bfeb33938b_header',
                            text: 'General doctor visits',
                            description: null,
                            modalContent: 'For example: general practitioner, eye doctor, gynecologist, pediatrician, emergency doctor',
                        },
                        {
                            cellId: 'table_row$197d1f4e-89cf-4deb-9f69-15bfeb33938b_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$197d1f4e-89cf-4deb-9f69-15bfeb33938b_1',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$197d1f4e-89cf-4deb-9f69-15bfeb33938b_2',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$197d1f4e-89cf-4deb-9f69-15bfeb33938b_3',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$8ed1cd8e-3d9b-440b-8dc1-824ad9d932b4_header',
                            text: 'Specialist doctor visits',
                            description: null,
                            modalContent: 'For example: dermatologist, orthopedic, Ear-Nose-Throat doctor',
                        },
                        {
                            cellId: 'table_row$8ed1cd8e-3d9b-440b-8dc1-824ad9d932b4_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$8ed1cd8e-3d9b-440b-8dc1-824ad9d932b4_1',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$8ed1cd8e-3d9b-440b-8dc1-824ad9d932b4_2',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$8ed1cd8e-3d9b-440b-8dc1-824ad9d932b4_3',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$077a9a1c-15e8-4499-b204-7df9785b1ae5_header',
                            text: 'Medication',
                            description: null,
                            modalContent: 'Public insurance covers the cost of medication, but the insured person pays part of it as a co-payment. Insured persons pay ten percent of the retail price for each prescription drug per package, up to a maximum of €10 and a minimum of €5.',
                        },
                        {
                            cellId: 'table_row$077a9a1c-15e8-4499-b204-7df9785b1ae5_0',
                            text: 'Around 90%',
                        },
                        {
                            cellId: 'table_row$077a9a1c-15e8-4499-b204-7df9785b1ae5_1',
                            text: 'Around 90%',
                        },
                        {
                            cellId: 'table_row$077a9a1c-15e8-4499-b204-7df9785b1ae5_2',
                            text: 'Around 90%',
                        },
                        {
                            cellId: 'table_row$077a9a1c-15e8-4499-b204-7df9785b1ae5_3',
                            text: 'Around 90%',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$297a6006-65ef-46a7-8aa2-f7e786aed35d_header',
                            text: 'General vaccinations',
                            description: null,
                            modalContent: 'The following vaccinations are considered general vaccinations in Germany:\n- Chicken pox \n- Diphtheria\n- Hib (Haemophilus influenzae type B)\n- HPV\n- Measles (since 2020 it is mandatory by law to get this vaccination)\n- Mumps\n- Pneumococcus\n- Polio\n- Rotavirus\n- Rubella\n- Shingles (zoster)\n- Tetanus\n- Whooping cough (pertussis)',
                        },
                        {
                            cellId: 'table_row$297a6006-65ef-46a7-8aa2-f7e786aed35d_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$297a6006-65ef-46a7-8aa2-f7e786aed35d_1',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$297a6006-65ef-46a7-8aa2-f7e786aed35d_2',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$297a6006-65ef-46a7-8aa2-f7e786aed35d_3',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$58628772-f205-4bae-90fa-36f05f621b91_header',
                            text: 'Travel vaccinations',
                            description: null,
                            modalContent: 'The following vaccinations are considered travel vaccinations in Germany:\n- Cholera\n- TBE (Tick-borne encephalitis)\n- Yellow fever\n- Hepatitis A\n- Hepatitis B\n- Japanese encephalitis\n- Malaria prophylaxis\n- Meningococcus type ACWY\n- Meningococcus type C\n- Rabies\n- Typhus',
                        },
                        {
                            cellId: 'table_row$58628772-f205-4bae-90fa-36f05f621b91_0',
                            text: '11 out of 11',
                        },
                        {
                            cellId: 'table_row$58628772-f205-4bae-90fa-36f05f621b91_1',
                            text: '11 out of 11',
                        },
                        {
                            cellId: 'table_row$58628772-f205-4bae-90fa-36f05f621b91_2',
                            text: '10 out of 11',
                        },
                        {
                            cellId: 'table_row$58628772-f205-4bae-90fa-36f05f621b91_3',
                            text: '11 out of 11',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$75f8c6bd-4c12-4305-b775-13b62076d59b_header',
                            text: 'Transports',
                            description: null,
                            modalContent: 'In the event of an emergency, ambulance, taxi or Uber to the closest suitable hospital or clinic. The return trip can be covered in some cases.\n\nNon-hospital transports only for dialysis or chemotherapy in the event of an emergency.',
                        },
                        {
                            cellId: 'table_row$75f8c6bd-4c12-4305-b775-13b62076d59b_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$75f8c6bd-4c12-4305-b775-13b62076d59b_1',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$75f8c6bd-4c12-4305-b775-13b62076d59b_2',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$75f8c6bd-4c12-4305-b775-13b62076d59b_3',
                            checkmarkValue: true,
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Dental',
                    icon: 'https://images.prismic.io/feather-website/ZqEU8x5LeNNTxdoK_dental-tooth-teeth.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$1c08c96c-2a9e-4d53-99f4-37ad2e9b5f01_header',
                            text: 'Dental checkups',
                            description: null,
                        },
                        {
                            cellId: 'table_row$1c08c96c-2a9e-4d53-99f4-37ad2e9b5f01_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$1c08c96c-2a9e-4d53-99f4-37ad2e9b5f01_1',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$1c08c96c-2a9e-4d53-99f4-37ad2e9b5f01_2',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$1c08c96c-2a9e-4d53-99f4-37ad2e9b5f01_3',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$87b8662c-b622-4b7d-a272-0c451d81ed96_header',
                            text: 'Dental cleanings',
                            description: 'Prophylaxis not covered on Public',
                            modalContent: 'Prophylaxis is generally not covered on Public. However, many providers do offer certain limited budget.',
                        },
                        {
                            cellId: 'table_row$87b8662c-b622-4b7d-a272-0c451d81ed96_0',
                            text: 'Removal of tartar once a year',
                        },
                        {
                            cellId: 'table_row$87b8662c-b622-4b7d-a272-0c451d81ed96_1',
                            text: 'Up to €40/year',
                        },
                        {
                            cellId: 'table_row$87b8662c-b622-4b7d-a272-0c451d81ed96_2',
                            text: 'Up to €60/year',
                            modalContent: 'Free at certain [dentists](https://www.dentnet.de/)',
                        },
                        {
                            cellId: 'table_row$87b8662c-b622-4b7d-a272-0c451d81ed96_3',
                            text: 'Up to €50/year',
                            modalContent: 'Offer depends on the regional AOK branch',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$e62de865-1476-47d6-9d88-132983b93ff5_header',
                            text: 'Dentist treatment',
                            description: 'E.g. fillings',
                            modalContent: 'Amalgam fillings are covered by the public provider. If amalgam is no longer used in the practice, an alternative must be offered by a dentist without a co-payment.\n\nFillings made of plastic (composites) are covered only up to and including tooth three in the front region.',
                        },
                        {
                            cellId: 'table_row$e62de865-1476-47d6-9d88-132983b93ff5_0',
                            text: 'Basic treatments only',
                        },
                        {
                            cellId: 'table_row$e62de865-1476-47d6-9d88-132983b93ff5_1',
                            text: 'Basic treatments only',
                        },
                        {
                            cellId: 'table_row$e62de865-1476-47d6-9d88-132983b93ff5_2',
                            text: 'Basic treatments only',
                        },
                        {
                            cellId: 'table_row$e62de865-1476-47d6-9d88-132983b93ff5_3',
                            text: 'Basic treatments only',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$cb766fa4-e56d-48dd-ba0b-be18176fdb01_header',
                            text: 'Tooth replacement',
                            description: 'Implants e.g. minimum quality (metal) crowns',
                            modalContent: 'Depending on the quality of material for your tooth replacement the percentage of coverage might change. For instance, if you go with ceramic material, it might only be covered up to 30%.',
                        },
                        {
                            cellId: 'table_row$cb766fa4-e56d-48dd-ba0b-be18176fdb01_0',
                            text: '60%, up to 70% (5 years) or even 75% (10 years) with complete bonus book',
                        },
                        {
                            cellId: 'table_row$cb766fa4-e56d-48dd-ba0b-be18176fdb01_1',
                            text: '60%, up to 70% (5 years) or even 75% (10 years) with complete bonus book',
                        },
                        {
                            cellId: 'table_row$cb766fa4-e56d-48dd-ba0b-be18176fdb01_2',
                            text: '60%, up to 70% (5 years) or even 75% (10 years) with complete bonus book',
                        },
                        {
                            cellId: 'table_row$cb766fa4-e56d-48dd-ba0b-be18176fdb01_3',
                            text: '60%, up to 70% (5 years) or even 75% (10 years) with complete bonus book',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$5a5765ce-2750-4283-a2f9-3a41e4070c5e_header',
                            type: 'CARD',
                            title: 'Dental add-on',
                            description: 'Get your dental cleanings and additional treatments covered for just 10.90€ a month.',
                            colSpan: 4,
                            icon: 'https://images.prismic.io/feather-website/Zulj-7VsGrYSvbNL_Dental-cross.png?auto=format,compress',
                            href: 'https://feather-insurance.com/dental-insurance',
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Treatment and therapies',
                    icon: 'https://images.prismic.io/feather-website/ZqEVHx5LeNNTxdoP_activity.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$89a3ed4c-2271-480f-97b4-0af938890d58_header',
                            text: 'Preventive care treatments',
                            description: null,
                            modalContent: 'Most preventive care treatments are only available after the age of 35 (full body checkup, skin cancer screening). There are no age restrictions for annual gynaecological check-ups. Here is a [complete list](https://www-krankenkassen-de.translate.goog/gesetzliche-krankenkassen/leistungen-gesetzliche-krankenkassen/gesetzlich-vorgeschriebene-leistungen/gesetzliche-krankenkassen-Vorsorgeuntersuchungen/?_x_tr_sl=auto&_x_tr_tl=en&_x_tr_hl=de).',
                        },
                        {
                            cellId: 'table_row$89a3ed4c-2271-480f-97b4-0af938890d58_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$89a3ed4c-2271-480f-97b4-0af938890d58_1',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$89a3ed4c-2271-480f-97b4-0af938890d58_2',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$89a3ed4c-2271-480f-97b4-0af938890d58_3',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$5381e2de-a78d-4b3e-a1e9-4c1886090de8_header',
                            text: 'Breast cancer screening',
                            description: null,
                            modalContent: '30 years and older can receive a yearly breast cancer screening\n\n50 - 69 years can also receive a yearly mammography',
                        },
                        {
                            cellId: 'table_row$5381e2de-a78d-4b3e-a1e9-4c1886090de8_0',
                            text: 'Only statutory screenings',
                        },
                        {
                            cellId: 'table_row$5381e2de-a78d-4b3e-a1e9-4c1886090de8_1',
                            text: 'Statutory screenings + extra free screenings from age 20',
                        },
                        {
                            cellId: 'table_row$5381e2de-a78d-4b3e-a1e9-4c1886090de8_2',
                            text: 'Only statutory screenings',
                        },
                        {
                            cellId: 'table_row$5381e2de-a78d-4b3e-a1e9-4c1886090de8_3',
                            text: 'Only statutory screenings',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$8940d859-dbda-4c04-80c7-123ce1387216_header',
                            text: 'Bowel cancer screening',
                            description: null,
                            modalContent: 'From age 50 -yearly immunological stool screening\n\nMen from age 50 and women from age 55 can have a preventive colonoscopy once every 10 years',
                        },
                        {
                            cellId: 'table_row$8940d859-dbda-4c04-80c7-123ce1387216_0',
                            text: 'Only statutory screenings',
                        },
                        {
                            cellId: 'table_row$8940d859-dbda-4c04-80c7-123ce1387216_1',
                            text: 'Only statutory screenings',
                        },
                        {
                            cellId: 'table_row$8940d859-dbda-4c04-80c7-123ce1387216_2',
                            text: 'Only statutory screenings',
                        },
                        {
                            cellId: 'table_row$8940d859-dbda-4c04-80c7-123ce1387216_3',
                            text: 'Screenings included from age 40',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$0cfedc83-0e99-4f78-a951-c88ec10d04b7_header',
                            text: 'Skin cancer screening',
                            description: null,
                            modalContent: 'Free screening every 2 years from age 35 up',
                        },
                        {
                            cellId: 'table_row$0cfedc83-0e99-4f78-a951-c88ec10d04b7_0',
                            text: 'Only statutory screenings',
                        },
                        {
                            cellId: 'table_row$0cfedc83-0e99-4f78-a951-c88ec10d04b7_1',
                            text: 'Free screening every 2 years from age 20 up',
                        },
                        {
                            cellId: 'table_row$0cfedc83-0e99-4f78-a951-c88ec10d04b7_2',
                            text: 'Only statutory screenings',
                        },
                        {
                            cellId: 'table_row$0cfedc83-0e99-4f78-a951-c88ec10d04b7_3',
                            text: 'Only statutory screenings',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$5c100a28-12df-429b-9212-8b4377e2397d_header',
                            text: 'Therapeutic measures',
                            description: 'E.g. physio therapy or speech therapy',
                            modalContent: 'The amount of prescribed sessions for a condition (e.g. physio therapy) is usually limited to a handful of sessions for most conditions.',
                        },
                        {
                            cellId: 'table_row$5c100a28-12df-429b-9212-8b4377e2397d_0',
                            text: '90%',
                            hideProgressBar: true,
                        },
                        {
                            cellId: 'table_row$5c100a28-12df-429b-9212-8b4377e2397d_1',
                            text: '90%',
                            hideProgressBar: true,
                        },
                        {
                            cellId: 'table_row$5c100a28-12df-429b-9212-8b4377e2397d_2',
                            text: '90%',
                            hideProgressBar: true,
                        },
                        {
                            cellId: 'table_row$5c100a28-12df-429b-9212-8b4377e2397d_3',
                            text: '90%',
                            hideProgressBar: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$bac7a178-e2ef-466e-ac82-476c04c7dfbe_header',
                            text: 'Mental health therapy',
                            description: null,
                            modalContent: 'Pre-approval required. Finding a therapist may be difficult.',
                        },
                        {
                            cellId: 'table_row$bac7a178-e2ef-466e-ac82-476c04c7dfbe_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$bac7a178-e2ef-466e-ac82-476c04c7dfbe_1',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$bac7a178-e2ef-466e-ac82-476c04c7dfbe_2',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$bac7a178-e2ef-466e-ac82-476c04c7dfbe_3',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$d5bf65bc-9576-43e2-9e57-3cd03359448e_header',
                            text: 'Natural health treatments',
                            description: null,
                        },
                        {
                            cellId: 'table_row$d5bf65bc-9576-43e2-9e57-3cd03359448e_0',
                            text: 'Acupuncture, homeopathy, osteopathy (also for newborn and pregnant women) and traditional Chinese medicine',
                        },
                        {
                            cellId: 'table_row$d5bf65bc-9576-43e2-9e57-3cd03359448e_1',
                            text: 'Natural medicine + homeopathy are paid for',
                        },
                        {
                            cellId: 'table_row$d5bf65bc-9576-43e2-9e57-3cd03359448e_2',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$d5bf65bc-9576-43e2-9e57-3cd03359448e_3',
                            checkmarkValue: false,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$58c62219-64dd-4a1e-bae2-1663b6c42ddf_header',
                            text: 'Medical aids',
                            description: null,
                            modalContent: 'Medical aids: 90%\n\nHearing aids: 75%, up to €780',
                        },
                        {
                            cellId: 'table_row$58c62219-64dd-4a1e-bae2-1663b6c42ddf_0',
                            text: '75% - 90%',
                        },
                        {
                            cellId: 'table_row$58c62219-64dd-4a1e-bae2-1663b6c42ddf_1',
                            text: '75% - 90%',
                        },
                        {
                            cellId: 'table_row$58c62219-64dd-4a1e-bae2-1663b6c42ddf_2',
                            text: '75% - 90%',
                        },
                        {
                            cellId: 'table_row$58c62219-64dd-4a1e-bae2-1663b6c42ddf_3',
                            text: '75% - 90%',
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Vision',
                    icon: 'https://images.prismic.io/feather-website/ZqEVLh5LeNNTxdoY_eye-vision.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$dbc54193-23c4-44e3-88e1-dc957a7ddb05_header',
                            text: 'Vision aids',
                            description: 'E.g. glasses or contact lenses',
                            modalContent: 'Lenses are covered for minors, coverage for adults under certain conditions (very limited vision).',
                        },
                        {
                            cellId: 'table_row$dbc54193-23c4-44e3-88e1-dc957a7ddb05_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$dbc54193-23c4-44e3-88e1-dc957a7ddb05_1',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$dbc54193-23c4-44e3-88e1-dc957a7ddb05_2',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$dbc54193-23c4-44e3-88e1-dc957a7ddb05_3',
                            checkmarkValue: false,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$e7396c2f-41f7-4df4-ade1-78efecd826df_header',
                            text: 'Refractive eye surgery',
                            description: 'E.g. LASIK',
                            modalContent: 'Refractive eye surgery is not covered, unless it is medically necessary, like cataract.',
                        },
                        {
                            cellId: 'table_row$e7396c2f-41f7-4df4-ade1-78efecd826df_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$e7396c2f-41f7-4df4-ade1-78efecd826df_1',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$e7396c2f-41f7-4df4-ade1-78efecd826df_2',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$e7396c2f-41f7-4df4-ade1-78efecd826df_3',
                            checkmarkValue: false,
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Pregnancy and childbirth',
                    icon: 'https://images.prismic.io/feather-website/ZqEUrR5LeNNTxdoF_dependents-family.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$73b76f5c-0481-417b-926e-d6063416a4b2_header',
                            text: 'General pregnancy cover',
                            description: null,
                        },
                        {
                            cellId: 'table_row$73b76f5c-0481-417b-926e-d6063416a4b2_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$73b76f5c-0481-417b-926e-d6063416a4b2_1',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$73b76f5c-0481-417b-926e-d6063416a4b2_2',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$73b76f5c-0481-417b-926e-d6063416a4b2_3',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$7a0e4476-4416-4595-b392-1106a59094a4_header',
                            text: 'Extra screenings',
                            description: null,
                            modalContent: 'Pregnancy care on public health insurance covers a wide variety of medically necessary screenings set by the German government. These are the same regardless of the provider you choose.\nThere are however supplemental tests that the different providers may offer.\nThese tests are:\n- Chickenpox antibody test\n- Fifth disease antibody test\n- First trimester screening\n- Neck fold measurement\n- Strep antibody test\n- Toxoplasmosis test chickenpox antibody test\n- Triple-Test\n- Extra ultrasound screening',
                        },
                        {
                            cellId: 'table_row$7a0e4476-4416-4595-b392-1106a59094a4_0',
                            text: '3/8 tests covered',
                            modalContent: 'Up to €200 combined.\n\n**Only covers:**\n\n- Strep antibody test\n\n- Toxoplasmosis test',
                        },
                        {
                            cellId: 'table_row$7a0e4476-4416-4595-b392-1106a59094a4_1',
                            text: '5/8 tests covered',
                            modalContent: '**Not covered:**\n\n- First trimester screening\n\n- Neck fold measurement\n\n- Triple-test not covered',
                        },
                        {
                            cellId: 'table_row$7a0e4476-4416-4595-b392-1106a59094a4_2',
                            text: '6/8 tests covered',
                            modalContent: 'Up to €500 combined.\nExtra ultrasound screenings fully covered\n\n**Not covered:**\n\n- First trimester screening\n\n- Triple-test',
                        },
                        {
                            cellId: 'table_row$7a0e4476-4416-4595-b392-1106a59094a4_3',
                            text: '6/8 tests covered',
                            modalContent: 'Up to €100 combined.\nOnly 3 ultrasound tests covered.\nFirst trimester screening not covered.',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$008476c1-af1c-434a-afdf-0ac04e71a794_header',
                            text: 'Fertility treatment',
                            description: null,
                            modalContent: 'Fertility treatments such as in-vitro fertilisation (IVF) are sometimes partially covered for married couples (age 25-40). Pre-approval is required.',
                        },
                        {
                            cellId: 'table_row$008476c1-af1c-434a-afdf-0ac04e71a794_0',
                            text: 'Up to 50% of costs under very limited situations',
                            modalContent: 'Married couples where the woman is between 25 and 39 years old and the man is between 25 and 49 years old. A doctor needs to determine that IVF is necessary to become pregnant',
                        },
                        {
                            cellId: 'table_row$008476c1-af1c-434a-afdf-0ac04e71a794_1',
                            text: '€250 + bonus if both partners are insured with TK',
                        },
                        {
                            cellId: 'table_row$008476c1-af1c-434a-afdf-0ac04e71a794_2',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$008476c1-af1c-434a-afdf-0ac04e71a794_3',
                            checkmarkValue: false,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$9d9af743-cc48-4ab4-87ab-4816868285b0_header',
                            text: 'Help by a midwife',
                            description: 'Before and after giving birth',
                        },
                        {
                            cellId: 'table_row$9d9af743-cc48-4ab4-87ab-4816868285b0_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$9d9af743-cc48-4ab4-87ab-4816868285b0_1',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$9d9af743-cc48-4ab4-87ab-4816868285b0_2',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$9d9af743-cc48-4ab4-87ab-4816868285b0_3',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$140d2c30-f26e-4cc6-97f1-5d4ea524b1cd_header',
                            text: 'Midwife on call',
                            description: null,
                        },
                        {
                            cellId: 'table_row$140d2c30-f26e-4cc6-97f1-5d4ea524b1cd_0',
                            text: '€200 / year',
                        },
                        {
                            cellId: 'table_row$140d2c30-f26e-4cc6-97f1-5d4ea524b1cd_1',
                            text: '€250 / year',
                        },
                        {
                            cellId: 'table_row$140d2c30-f26e-4cc6-97f1-5d4ea524b1cd_2',
                            text: '€500 / year',
                        },
                        {
                            cellId: 'table_row$140d2c30-f26e-4cc6-97f1-5d4ea524b1cd_3',
                            text: '€500 / year',
                            modalContent: 'Offer depends on the regional AOK branch',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$bffb6c0c-af99-41cd-a404-040eff06b208_header',
                            text: 'Birth preparation course for partner',
                            description: null,
                        },
                        {
                            cellId: 'table_row$bffb6c0c-af99-41cd-a404-040eff06b208_0',
                            text: '€200 / pregnancy',
                        },
                        {
                            cellId: 'table_row$bffb6c0c-af99-41cd-a404-040eff06b208_1',
                            text: '€100 / pregnancy',
                        },
                        {
                            cellId: 'table_row$bffb6c0c-af99-41cd-a404-040eff06b208_2',
                            text: '€500 / pregnancy',
                        },
                        {
                            cellId: 'table_row$bffb6c0c-af99-41cd-a404-040eff06b208_3',
                            text: '€500 / year',
                            modalContent: 'Offer depends on the regional AOK branch',
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Hospital',
                    icon: 'https://images.prismic.io/feather-website/ZqEUqx5LeNNTxdoD_hospital-building.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$50298a74-7720-4d9e-80ed-556fb2e3daed_header',
                            text: 'Board and room',
                            description: 'At the hospital',
                        },
                        {
                            cellId: 'table_row$50298a74-7720-4d9e-80ed-556fb2e3daed_0',
                            text: 'Shared room',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$50298a74-7720-4d9e-80ed-556fb2e3daed_1',
                            text: 'Shared room',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$50298a74-7720-4d9e-80ed-556fb2e3daed_2',
                            text: 'Shared room',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$50298a74-7720-4d9e-80ed-556fb2e3daed_3',
                            text: 'Shared room',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$0a86f47a-216a-448a-8bc5-b0e9f662813b_header',
                            text: 'Free choice of hospital',
                            description: null,
                        },
                        {
                            cellId: 'table_row$0a86f47a-216a-448a-8bc5-b0e9f662813b_0',
                            text: 'All public hospitals',
                        },
                        {
                            cellId: 'table_row$0a86f47a-216a-448a-8bc5-b0e9f662813b_1',
                            text: 'All public hospitals',
                        },
                        {
                            cellId: 'table_row$0a86f47a-216a-448a-8bc5-b0e9f662813b_2',
                            text: 'All public hospitals',
                        },
                        {
                            cellId: 'table_row$0a86f47a-216a-448a-8bc5-b0e9f662813b_3',
                            text: 'All public hospitals',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$99e9ac84-d9d9-47a2-945b-b7ea0a02475f_header',
                            text: 'Private hospitals',
                            description: null,
                        },
                        {
                            cellId: 'table_row$99e9ac84-d9d9-47a2-945b-b7ea0a02475f_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$99e9ac84-d9d9-47a2-945b-b7ea0a02475f_1',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$99e9ac84-d9d9-47a2-945b-b7ea0a02475f_2',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$99e9ac84-d9d9-47a2-945b-b7ea0a02475f_3',
                            checkmarkValue: false,
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Outside of Germany',
                    icon: 'https://images.prismic.io/feather-website/ZqEUqh5LeNNTxdoC_globe-network-earth.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$277be744-91ac-4b60-a121-0ab94372ae77_header',
                            text: 'EU-wide cover',
                            description: 'Including the EEA',
                            modalContent: '[For short-term stays in most European countries using the European Health Insurance Card (EHIC)](https://faq.eu.feather-insurance.com/en/articles/29608-what-is-ehic-european-health-insurance-card)',
                        },
                        {
                            cellId: 'table_row$277be744-91ac-4b60-a121-0ab94372ae77_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$277be744-91ac-4b60-a121-0ab94372ae77_1',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$277be744-91ac-4b60-a121-0ab94372ae77_2',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$277be744-91ac-4b60-a121-0ab94372ae77_3',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$8dfbf7dd-8786-4dfb-890f-a807260585f4_header',
                            text: 'Worldwide cover',
                            description: null,
                        },
                        {
                            cellId: 'table_row$8dfbf7dd-8786-4dfb-890f-a807260585f4_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$8dfbf7dd-8786-4dfb-890f-a807260585f4_1',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$8dfbf7dd-8786-4dfb-890f-a807260585f4_2',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$8dfbf7dd-8786-4dfb-890f-a807260585f4_3',
                            checkmarkValue: false,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$041110af-c496-49fe-8388-179abd1db701_header',
                            text: 'Holiday travel cover',
                            description: null,
                        },
                        {
                            cellId: 'table_row$041110af-c496-49fe-8388-179abd1db701_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$041110af-c496-49fe-8388-179abd1db701_1',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$041110af-c496-49fe-8388-179abd1db701_2',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$041110af-c496-49fe-8388-179abd1db701_3',
                            checkmarkValue: false,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$9084adc6-2f8f-4b92-b87b-d44c31bd5ebb_header',
                            text: 'Repatriation costs',
                            description: null,
                        },
                        {
                            cellId: 'table_row$9084adc6-2f8f-4b92-b87b-d44c31bd5ebb_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$9084adc6-2f8f-4b92-b87b-d44c31bd5ebb_1',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$9084adc6-2f8f-4b92-b87b-d44c31bd5ebb_2',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$9084adc6-2f8f-4b92-b87b-d44c31bd5ebb_3',
                            checkmarkValue: false,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$9bacc6bc-03c4-46e7-a9b4-0a3717812474_header',
                            type: 'CARD',
                            title: 'Travel insurance',
                            description: 'Avoid medical expenses on trips outside of Germany for just 18€ a year.',
                            colSpan: 4,
                            icon: 'https://images.prismic.io/feather-website/ZulkQ7VsGrYSvbNa_Travel-cross.png?auto=format,compress',
                            href: 'https://feather-insurance.com/travel-health-insurance',
                        },
                    ],
                ],
            },
        ],
    },
};
